import { DaoService } from "./DaoService";

export class PersonnelService extends DaoService {

    static CLASS_NAME = "App\\Models\\Personnel";
    
    static getInstance() {
        return super.getInstance('personnel');
    }

    enable(idOrUid) {
        return PersonnelService.post(`${this.prefix}/${idOrUid}/enable`);
    }

    disable(idOrUid) {
        return PersonnelService.post(`${this.prefix}/${idOrUid}/disable`);
    }

    all() {
        return PersonnelService.get(`${this.prefix}/all`);
    }

    getPersonnelsAttachedToMyTickets(uid) {
        return PersonnelService.get(`${this.prefix}/${uid}/attached-to-my-tickets`);
    }

    mesSubordonnes() {
        return PersonnelService.get(`${this.prefix}/mes-subordonnes`);
    }

    monEquipeDetail(uid) {
        return PersonnelService.get(`${this.prefix}/${uid}/mon-equipe-detail`);
    }


    search(data) {
        return PersonnelService.post(`${this.prefix}/search`, data);
    }

    syncFromSiRH() {
        return PersonnelService.post(`${this.prefix}/sync-from-sirh`);
    }

}